// extracted by mini-css-extract-plugin
export default {"KeywordsDataTable":"Alerts_KeywordsDataTable__SmG96","scrollable":"Alerts_scrollable__vVTF3"};